import React from 'react';
import { Link } from 'react-router-dom';
import { Scale } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm">
            © 2024 UAE Legal Directory. All rights reserved. Data sourced from <a href="https://legal.dubai.gov.ae/" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 underline">Dubai Legal Affairs Department</a>.
          </div>
          <div className="flex flex-wrap gap-4 mt-4 md:mt-0 justify-center md:justify-end">
            <Link to="/terms-of-use" className="text-gray-400 hover:text-white text-sm transition-colors">Terms of Use</Link>
            <Link to="/legal-disclaimer" className="text-gray-400 hover:text-white text-sm transition-colors">Legal Disclaimer</Link>
            <Link to="/privacy" className="text-gray-400 hover:text-white text-sm transition-colors">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;